/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const CREATE_GTIN = gql`
    mutation CreateGtin(
        $name: String!
        $item: ID!
        $gtinKey: String!
        $desc: [DescSchemaInput]
        $assets: AllAssetsSchemaInput
        $attrs: [AttrSchemaInput]!
        $dateAttrs: [DateAttrSchemaInput]
    ) {
        createGtin(
            name: $name
            item: $item
            gtinKey: $gtinKey
            desc: $desc
            assets: $assets
            attrs: $attrs
            date_attrs: $dateAttrs
        ) {
            _id
            item
            name
            lname
            from
            price
            gtinKey
        }
    }
`;
